import React from 'react'
import Spinner from 'react-md-spinner'
import styles from './Loader.module.scss'

type LoaderProps = {
  size?: number,
}

export const Loader: React.FC<LoaderProps> = (props) => {
  const { size = 32 } = props
  return (
    <div className={styles.loader}>
      <Spinner size={size} singleColor={'#FFD9CD'} borderSize={4} />
    </div>
  )
}
